import { render, staticRenderFns } from "./productsReadOnly.vue?vue&type=template&id=e11048ca&class=app-bg-login&"
import script from "./productsReadOnly.vue?vue&type=script&lang=ts&"
export * from "./productsReadOnly.vue?vue&type=script&lang=ts&"
import style0 from "./productsReadOnly.vue?vue&type=style&index=0&id=e11048ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports